import { render, staticRenderFns } from "./RestrictionsManagement.vue?vue&type=template&id=186ab2d1&scoped=true&"
import script from "./RestrictionsManagement.vue?vue&type=script&lang=js&"
export * from "./RestrictionsManagement.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionsManagement.vue?vue&type=style&index=0&id=186ab2d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ab2d1",
  null
  
)

export default component.exports